/**
 * Wartet auf das Erscheinen eines Elements im DOM
 *
 * Nutzt MutationObserver um auf dynamisch eingefügte Elemente zu warten.
 * Nützlich wenn Custom Elements oder andere Inhalte asynchron geladen werden.
 *
 * @param {HTMLElement} container - Container-Element, in dem gesucht wird
 * @param {string} selector - CSS-Selektor für das gesuchte Element
 * @param {number} timeout - Maximale Wartezeit in Millisekunden (default: 200ms)
 * @returns {Promise<HTMLElement|null>} Das gefundene Element oder null bei Timeout
 *
 * @example
 * const element = await waitForElement(form, "dl-submit", 200);
 * if (element) {
 *   console.log("Element gefunden:", element);
 * }
 */
export default function waitForElement(container, selector, timeout = 200) {
    return new Promise((resolve) => {
        // Prüfe zunächst, ob Element bereits vorhanden ist
        const existingElement = container.querySelector(selector);
        if (existingElement) {
            resolve(existingElement);
            return;
        }

        let timeoutId;
        const observer = new MutationObserver(() => {
            const element = container.querySelector(selector);
            if (element) {
                clearTimeout(timeoutId);
                observer.disconnect();
                resolve(element);
            }
        });

        // Beobachte Änderungen im Container
        observer.observe(container, {
            childList: true,
            subtree: true
        });

        // Timeout als Fallback
        timeoutId = setTimeout(() => {
            observer.disconnect();
            resolve(null);
        }, timeout);
    });
}
